export default __webpack_public_path__ + "static/media/P3.81f37b2e.png";